







import {Component, Prop, Watch} from 'vue-property-decorator'

import {LatLng} from './models/LatLng'
import {MarkerLabel} from './models/MarkerLabel'
import NMapChildren from './NMapChildren.vue'

@Component({
  components: {},
})
export default class NMapMarker extends NMapChildren {
  @Prop() public position!: LatLng
  @Prop() public icon!: string
  @Prop() public label?: MarkerLabel

  public init() {
    this.item = this.providerInstance().addMarker(
      this.position,
      this.icon,
      this.$slots.default ? this.$slots.default[0].elm : null,
      this.$listeners && this.$listeners.click ? () => {
        this.$emit('click')
      } : null,
      !!(this.$parent as any).isNMapMarkerCluster,
      this.label,
    )
  }

  @Watch('position')
  public valueChanged(nuval: LatLng, olval: LatLng) {
    const equals = LatLng.equals(nuval, olval)
    if (!this.isReady() || equals) {
      return
    }
    this.clean()
    this.init()
  }
}
